// extracted by mini-css-extract-plugin
export default {"container":"MainLayout_container__ktLTz","main":"MainLayout_main__EACSc","main__content":"MainLayout_main__content__q6U3M","close_sidebar":"MainLayout_close_sidebar__3S4tk"};